<template>
  <div>
    <div>
      <el-date-picker
        style="float: right; width: 220px"
        v-model="filters.date"
        type="daterange"
        :clearable="false"
        size="mini">
      </el-date-picker>
      <h4 class="header-title m-t-0 m-b-20">Rappels du jour et passés</h4>
    </div>

    <div class="row m-b-10">
      <div class="col-md-6">
        <el-select clearable multiple class="form-control" v-model="filters.categories" placeholder="Filtrer par type de rappel">
          <el-option
            v-for="category in categories"
            :key="category.id"
            :label="category.name"
            :value="category.id">
          </el-option>
        </el-select>
      </div>
      <div class="col-md-6">
        <el-select filterable clearable class="form-control" v-model="filters.customer"
                   placeholder="Filtrer par client ou prospect">
          <el-option
            v-for="customer in models.customers"
            :key="customer.id"
            :label="customer.name"
            :value="customer.id">
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="row m-b-10">
      <div class="col-md-12" style="text-align: right;">
        <el-button type="warning" size="small" :disabled="selected.length === 0" @click="openMoveReminders">Modifier la selection</el-button>
      </div>
    </div>

    <list-timetable v-loading="loading" style="min-height: 100px;" :from="filters.date[0]" :to="filters.date[1]" :events="events" :reverse="true">
      <template slot="header" slot-scope="props">
        <header>
          <el-checkbox :checked="false" :data-block-day-id="moment(props.day.date).format('YYYY-MM-DD')" style="margin-bottom: -4px;"  @change="handleDayCheckboxChanges"></el-checkbox>
          {{ props.day.date | moment("dddd DD") }}
          {{ props.day.date | moment("MMMM") }}
          <span>{{ props.day.date | moment("DD/MM/YYYY") }}</span>
        </header>
      </template>
      <template slot-scope="props">
        <div class="timetable-name">
          <div class="row">
            <div class="col-md-5">
              <!--
                <el-tooltip class="item" effect="dark" content="Ajouter à la session de travail" placement="top">
                  <el-button size="mini" type="info" v-on:click="pushReminderToTaskList(props.event.meta.reminder)">
                    <i class="fa fa-paperclip"></i>
                  </el-button>
                </el-tooltip>
              -->
              <el-checkbox :checked="false" :data-day-id="moment(props.event.date.from).format('YYYY-MM-DD')" :data-id="props.event.meta.reminder.id" @change="handleCheckboxChanges"></el-checkbox>
              <i class="fa fa-calendar-check-o" v-if="props.event.meta.reminder.meeting"></i>
              <strong>{{ props.event.title }}</strong>
              <span v-if="props.event.meta.reminder.meeting"> à {{ props.event.date.from | moment('H:mm') }}</span>
              <span
                v-if="props.event.description && props.event.description.trim() !== ''"> : {{ props.event.description }}</span>
            </div>
            <div class="col-md-5">
              <customer :item="models.customers.find(customer => customer.id === props.event.meta.reminder.customer_id)"></customer>
            </div>
            <div class="col-md-2">
              <div class="pull-right">
                    <span class="timetable-name">
                      <el-button type="warning" size="mini" v-edit:reminder="props.event.meta.reminder"
                                 icon="el-icon-edit" circle></el-button>
                      <el-button type="danger" size="mini" v-delete:reminder="props.event.meta.reminder"
                                 icon="el-icon-close" circle></el-button>
                    </span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </list-timetable>
    <div style="clear: both"></div>
  </div>
</template>

<script>
  import ListTimetable from 'vue-timetable/components/ListTimetable'
  import Customer from '../../Entities/Customer.vue'
  import { events } from '../../../model/utils/event-bus'
  import moment from 'moment'
  let $ = window.$

  export default {
    components: {ListTimetable, Customer},
    name: 'reminders-list-widget',
    props: ['defaultFilters'],
    data () {
      return {
        filters: Object.assign({
          categories: [],
          customer: null,
          date: [
            moment().subtract(this.$store.getters['user_preferences/current'].payload.reminders.show_since_days, 'days'),
            moment()
          ]
        }, this.defaultFilters),
        selected: [],
        models: {
          reminders: [],
          customers: []
        },
        loading: false
      }
    },
    sync: {
      models: {
        reminders () {
          let self = this

          return {
            name: 'reminder',
            onCreate ({index, data, model}) {
              if (!(self.filters.categories.length === 0 || self.filters.categories.includes(model.category_id))) return false
              if (!(self.filters.customer === null || self.filters.customer === model.customer_id)) return false
              if (!(model.user_id === self.$store.getters['users/current'].id)) return false
              if (!(moment(model.date.date).isBetween(self.filters.date[0].clone().startOf('day'), self.filters.date[1].clone().endOf('day')))) return false
              return true
            }
          }
        },
        customers: 'customer'
      }
    },
    computed: {
      events () {
        let self = this

        return this.models.reminders.map(item => {
          return self.$model['reminder'].toEvent(item)
        })
      },
      categories () {
        return this.$store.getters['reminder_categories/all']
      }
    },
    methods: {
      openMoveReminders () {
        events.emit('app/reminder/move', {
          ids: this.selected
        })
        $('[data-id] span').removeClass('is-checked')
        $('[data-block-day-id] span').removeClass('is-checked')
        this.selected = []
      },
      handleDayCheckboxChanges (events) {
        let self = this
        let dayId = $(event.target).parents('label').data('block-day-id')
        $('[data-day-id="' + dayId + '"]').each((i, el) => {
          let id = $(el).data('id')
          if($(el).find('span').hasClass('is-checked')) {
            $(el).find('span').removeClass('is-checked')
            self.selected = this.selected.filter(item => item !== id)
          } else {
            $(el).find('span').addClass('is-checked')
            self.selected.push(id)
          }
        })
      },
      handleCheckboxChanges (event) {
        let id = $(event.target).parents('label').data('id')
        if(event.target.checked) {
          this.selected.push(id)
        } else {
          this.selected = this.selected.filter(item => item !== id)
        }
      },
      pushReminderToTaskList (reminder) {
        this.$store.dispatch('task_lists/createTaskOnCurrentList', {
          payload: {
            reminder
          },
          component: 'ReminderTask'
        })
      },
      load () {
        let self = this

        let where = {
          user_id: this.$store.getters['users/current'].id,
          date: {
            '>=': moment(self.filters.date[0]).format('YYYY-MM-DD'),
            '<=': moment(self.filters.date[1]).format('YYYY-MM-DD')
          }
        }
        if (self.filters.categories.length > 0) where.category_id = {'IN': self.filters.categories.join(',')}
        if (self.filters.customer) where.customer_id = self.filters.customer

        this.loading = true
        this.$nexus.get('callcenter', 'reminders', { params: { where } }).then(response => {
          self.models.reminders = response.data.data
          self.loading = false
        })
      }
    },
    created () {
      this.load()
    },
    watch: {
      'models.reminders' () {
        let self = this

        this.$model.customer.getFromRelations(self.models.reminders).then(customers => {
          self.models.customers = customers
        })
      },
      filters: {
        handler (value) {
          this.load()
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RemindersListWidget.vue?222ec5ab